/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/react-in-jsx-scope */
import Button from '@mui/material/Button'
import React from 'react'

import { DEFAULT_SIZE_CHART, SHIRT_KEY } from '../../../constants/models'

interface ChartButtonProps {
  label: string
  sizeChart?: string
  onClick: (url: string) => void
}

const ChartButton = ({ label, sizeChart, onClick }: ChartButtonProps) => (
  <Button color="primary" onClick={() => onClick(sizeChart || DEFAULT_SIZE_CHART)}>
    View {label} Size Chart
  </Button>
)

interface SizeChartButtonsProps {
  shirtDetails?: Record<string, any>
  categoryId?: string
  categories?: Array<{ id: string; hasJersey?: boolean; hasShirt2?: boolean }>
  hasShirt2?: boolean
  hasJersey?: boolean
  jerseySizeChart?: string
  onShowSize: (url: string) => void
}

/**
 * Renders size chart buttons for SHIRT1, SHIRT2, and jersey.
 * Used by IndividualRegistration and StepParticipant.
 */
const SizeChartButtons = ({
  shirtDetails,
  categoryId,
  categories,
  hasShirt2,
  hasJersey,
  jerseySizeChart,
  onShowSize,
}: SizeChartButtonsProps) => {
  const categoryHasJersey =
    hasJersey ??
    categories?.filter((cat) => cat.id === categoryId)[0]?.hasJersey ??
    false
  const categoryHasShirt2 =
    hasShirt2 ??
    categories?.filter((cat) => cat.id === categoryId)[0]?.hasShirt2 ??
    false

  return (
    <div style={{ margin: 'auto', textAlign: 'center', marginBottom: '10px' }}>
      {shirtDetails?.SHIRT1 && (
        <ChartButton
          label={shirtDetails.SHIRT1.LABEL || 'Shirt'}
          sizeChart={shirtDetails.SHIRT1.SIZE_CHART}
          onClick={onShowSize}
        />
      )}
      {categoryHasShirt2 &&
        shirtDetails?.[SHIRT_KEY.SHIRT2] &&
        'SIZE_CHART' in shirtDetails[SHIRT_KEY.SHIRT2] && (
          <ChartButton
            label={shirtDetails[SHIRT_KEY.SHIRT2].LABEL || 'Shirt'}
            sizeChart={shirtDetails[SHIRT_KEY.SHIRT2].SIZE_CHART}
            onClick={onShowSize}
          />
        )}
      {categoryHasJersey && (
        <ChartButton
          label="Bike Jersey"
          sizeChart={jerseySizeChart}
          onClick={onShowSize}
        />
      )}
    </div>
  )
}

export default SizeChartButtons
